export var itemToString = item => {
  var _item$label;
  return String((_item$label = item === null || item === void 0 ? void 0 : item.label) !== null && _item$label !== void 0 ? _item$label : '');
};